import { convertNumber2Ord, formatDate, getPrice2decimal, getPrice3decimal } from 'utils'

export const fciLoanInfoSection: Record<string, string> = {
  statusEnum: 'Status',
  fciServiceProgram: 'FCI Service Program',
  isOnHold: 'On Hold',
  originalLoanAmount: 'Original Loan Amount',
  seniorloanAmounts: 'Funded Loan Amount',
  currentLoanAmount: 'Current Loan Amount',
  noteRate: 'Note Rate',
  investorRate: 'Investor Rate',
  defaultRate: 'Default Rate',
  lienPosition: 'Loan Position',
  escrowBalance: 'Escrow Balance',
  restrictedSuspense: 'Restricted Suspense',
  suspenseBalance: 'Suspense Balance',
  unpaidLateCharges: 'Unpaid Late Charges',
  accruedLateCharges: 'Accrued Late Charges',
  loanCharges: 'Loan Charges',
  unpaidInterest: 'Unpaid Interest',
  noteTypeEnum: 'Note Type',
  rateTypeEnum: 'Rate Type',
  propertyType: 'Property Type',
  propertyCounty: 'Property County',
  deferredPrinBal: 'Deferred Principal Balance',
  deferredUnpaidInt: 'Deferred Unpaid Interest',
  deferredUnpaidLateCharges: 'Deferred Unpaid Late Charges',
  deferredUnpaidLoanCharges: 'Deferred Unpaid Loan Charges',
}

export const fciDateInfoSection: Record<string, string> = {
  paidToDate: 'Paid To',
  nextPaymentDue: 'Next Payment Due',
  loanMaturity: 'Loan Maturity',
  loanPayoff: 'Loan Payoff',
  loanOrigination: 'Loan Origniation',
}

export const fciPaymentInfoSection: Record<string, string> = {
  aCHStatusEnum: 'ACH Status',
  totalPayment: 'Total Payment',
  payment: 'Principal & Interest',
  escrowPayment: 'Escrow Payment',
  suspensePayment: 'Suspense Payment',
  paymentOthers: 'Other Payments',
  graceDays: 'Grace Days',
  minimunLateCharges: 'Minimum Late Charge',
  lateChargesPct: 'Late Charge %',
}

export const fciBorrowerInfoSection: Record<string, string> = {
  account: 'Loan #',
  borrowerFullName: 'Borrower',
  borrowerTIN: 'TIN',
  borrowerMailingAddress: 'Mailing Address',
  fundedAmount: 'Senior Loan Amounts',
  unearnedDiscount: 'Unearned Disc',
  borrowerHomePhone: 'Home',
  borrowerWorkPhone: 'Work',
  borrowerMobilePhone: 'Mobile',
  borrowerFax: 'Fax',
  borrowerEmail: 'Email',
}

export enum FciValueTypes {
  Text = 'text',
  Number = 'number',
  Percent = 'percent',
  Boolean = 'boolean',
  Order = 'order',
  Date = 'date',
}
export const fciValueTypeMap: Record<string, FciValueTypes> = {
  statusEnum: FciValueTypes.Text,
  fciServiceProgram: FciValueTypes.Text,
  isOnHold: FciValueTypes.Boolean,
  originalLoanAmount: FciValueTypes.Number,
  seniorloanAmounts: FciValueTypes.Number,
  currentLoanAmount: FciValueTypes.Number,
  noteRate: FciValueTypes.Percent,
  investorRate: FciValueTypes.Percent,
  defaultRate: FciValueTypes.Percent,
  lienPosition: FciValueTypes.Order,
  escrowBalance: FciValueTypes.Number,
  restrictedSuspense: FciValueTypes.Number,
  suspenseBalance: FciValueTypes.Number,
  unpaidLateCharges: FciValueTypes.Number,
  accruedLateCharges: FciValueTypes.Number,
  loanCharges: FciValueTypes.Number,
  unpaidInterest: FciValueTypes.Number,
  noteTypeEnum: FciValueTypes.Text,
  rateTypeEnum: FciValueTypes.Text,
  propertyType: FciValueTypes.Text,
  propertyCounty: FciValueTypes.Text,
  deferredPrinBal: FciValueTypes.Number,
  deferredUnpaidInt: FciValueTypes.Number,
  deferredUnpaidLateCharges: FciValueTypes.Number,
  deferredUnpaidLoanCharges: FciValueTypes.Number,
  paidToDate: FciValueTypes.Text,
  nextPaymentDue: FciValueTypes.Text,
  loanMaturity: FciValueTypes.Text,
  loanPayoff: FciValueTypes.Text,
  loanOrigination: FciValueTypes.Text,
  aCHStatusEnum: FciValueTypes.Text,
  totalPayment: FciValueTypes.Number,
  payment: FciValueTypes.Number,
  escrowPayment: FciValueTypes.Number,
  suspensePayment: FciValueTypes.Number,
  paymentOthers: FciValueTypes.Number,
  graceDays: FciValueTypes.Text,
  minimunLateCharges: FciValueTypes.Number,
  lateChargesPct: FciValueTypes.Percent,
  account: FciValueTypes.Text,
  borrowerFullName: FciValueTypes.Text,
  borrowerTIN: FciValueTypes.Text,
  borrowerMailingAddress: FciValueTypes.Text,
  fundedAmount: FciValueTypes.Number,
  unearnedDiscount: FciValueTypes.Number,
  borrowerHomePhone: FciValueTypes.Text,
  borrowerWorkPhone: FciValueTypes.Text,
  borrowerMobilePhone: FciValueTypes.Text,
  borrowerFax: FciValueTypes.Text,
  borrowerEmail: FciValueTypes.Text,
}

export const renderFCIvalue = (value: any, type: FciValueTypes) => {
  switch (type) {
    case FciValueTypes.Boolean:
      return value ? 'Yes' : 'No'
    case FciValueTypes.Number:
      return value !== null ? `$${getPrice2decimal(value, false, true)}` : ''
    case FciValueTypes.Percent:
      return `${getPrice3decimal(value, false, true)}%`
    case FciValueTypes.Order:
      return convertNumber2Ord(value)
    case FciValueTypes.Date:
      return formatDate(value)
    default:
      return value
  }
}
